import axios from 'axios'
import { CommonDeviceTypeEnumResponse } from '@/api/services/common/device-type/common-device-type.dto'

class CommonDeviceTypeService {
    async getDeviceTypes(): Promise<CommonDeviceTypeEnumResponse[]> {
        const response = await axios.get<CommonDeviceTypeEnumResponse[]>(`configuration/deviceTypes`) // TODO: pending backend movement from configuration to common
        return response.data
    }
}

export const commonDeviceTypeService = new CommonDeviceTypeService()
